function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Coursebook");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "A solid styled icon from Orion Icon Library.");

var _ref4 = /*#__PURE__*/React.createElement("path", {
  "data-name": "layer2",
  d: "M3 31l27.5 12 32-18-26-11.5a8.6 8.6 0 0 0-7 .6L1.6 31A1.5 1.5 0 0 1 3 31z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  "data-name": "layer1",
  d: "M58.9 31.1L30.5 47 3.1 35.1a1.4 1.4 0 0 0-2 1.3 3.1 3.1 0 0 0 2 2.7L30.5 51l32.4-17.9z"
});

var SvgCoursebook = function SvgCoursebook(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    "aria-labelledby": "title",
    "aria-describedby": "desc",
    role: "img",
    fill: "currentColor",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCoursebook, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/coursebook.0cfce948.svg";
export { ForwardRef as ReactComponent };